/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Flex, useBreakpointIndex, useThemeUI } from '@tishman/components';
import React, { useContext } from 'react';
import * as Icons from '@tishman/icons';

import { CountdownTimerContext } from '../../../utils/countdown-timer-context-provider';
import { selectIsCountdownActive, useAppSelector } from '../../../store';

export interface CountdownProps {
  showDescription?: boolean;
  isSticky?: boolean;
}

const getMinutes = (timeLeft: number) => Math.floor(timeLeft! / 60).toString();
const getSeconds = (timeLeft: number) => (timeLeft % 60).toString();

export const CheckoutCountdown = ({
  showDescription = true,
  isSticky = false,
}: CountdownProps) => {
  const isCountdownActive = useAppSelector(selectIsCountdownActive);
  const themeUI = useThemeUI();
  const isMobile = useBreakpointIndex() < 2;

  const { timeRemaining } = useContext(CountdownTimerContext);

  if (!timeRemaining || !isCountdownActive) return null;

  return (
    <Flex
      sx={{
        flexDirection: ['column', 'row'],
        alignItems: 'center',
        fontSize: 2,
        mr: [2, 3],
        columnGap: 2,
        rowGap: 2,
        width: 'auto',
      }}
    >
      <Flex
        sx={{
          width: ['100%', 'auto'],
        }}
      >
        <Flex
          sx={{
            height: '40px',
            p: '8px 12px',
            borderRadius: '20px',
            backgroundColor: 'text',
            alignItems: 'center',
            columnGap: 2,
          }}
        >
          <Icons.Clock2 style={{ color: themeUI.theme.colors.textInverted }} />
          <span
            style={{
              fontWeight: 'bold',
              color: themeUI.theme.colors.textInverted,
            }}
          >
            {getMinutes(timeRemaining).padStart(2, '0')}:
            {getSeconds(timeRemaining).padStart(2, '0')}
          </span>
        </Flex>
      </Flex>
      {showDescription && (
        <span
          style={{
            display: isMobile ? (isSticky ? 'none' : 'inline') : 'inline',
            fontWeight: 500,
          }}
        >
          minutes left to complete your transaction
        </span>
      )}
    </Flex>
  );
};
